import BaseEndpoint from '@/api/endpoints/base-endpoint'

export default class ColorThemeEndpoint extends BaseEndpoint {}
